<div class="progress-wrapper">
  <svg class="progress-ring" width="150" height="150">
    <circle class="progress-ring__background" cx="75" cy="75" r="60"></circle>
    <circle
      class="progress-ring__circle"
      cx="75"
      cy="75"
      r="60"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="offset"
    ></circle>
  </svg>

  <div class="progress-text">
    <strong>{{ value }}%</strong>
    <p>Complete</p>
  </div>
</div>
